/**
 * Reader-facing words for the Audit screen. Only the vocabulary D3 introduced (the
 * operator-in-a-practice actions, their `practice_record` target), the four actions of a
 * practice deletion (D7: the deletion itself, cancelled, blocked, abandoned) and the operator's team role
 * have words; every other action and target type keeps the server's vocabulary verbatim
 * (S12 §3.3, widening labels is a follow-up). The raw value stays the filter value and the
 * tooltip: this is display text only.
 */
const ACTION_LABEL_KEYS = {
  "practice.enter": "audit.actionPracticeEnter",
  "practice.write": "audit.actionPracticeWrite",
  "tenant.delete": "audit.actionTenantDelete",
  "tenant.subscriptions_cancelled": "audit.actionTenantSubscriptionsCancelled",
  "tenant.delete_blocked": "audit.actionTenantDeleteBlocked",
  "tenant.delete_abandoned": "audit.actionTenantDeleteAbandoned",
};

const TARGET_LABEL_KEYS = {
  practice_record: "audit.targetPracticeRecord",
};

// The platform team roles (backend rbac.PLATFORM_ROLES), named by the Team screen's own keys.
// A role outside it (a system actor) is shown as stored.
const ROLE_LABEL_KEYS = {
  super_admin: "team.role.super_admin",
  finance: "team.role.finance",
  support: "team.role.support",
  viewer: "team.role.viewer",
};

const labelOf = (keys) => (t, value) => (Object.hasOwn(keys, value) ? t(keys[value]) : value);

/** `t`: the `superadmin` namespace translator. */
export const auditActionLabel = labelOf(ACTION_LABEL_KEYS);
export const auditTargetLabel = labelOf(TARGET_LABEL_KEYS);
export const auditRoleLabel = labelOf(ROLE_LABEL_KEYS);
